import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.4 12C1.4 6.146 6.146 1.4 12 1.4c1.661 0 3.236.383 4.638 1.067a1 1 0 0 1-.876 1.797A8.561 8.561 0 0 0 12 3.4a8.6 8.6 0 1 0 8.6 8.6 1 1 0 1 1 2 0c0 5.855-4.746 10.6-10.6 10.6-5.854 0-10.6-4.745-10.6-10.6Zm19.107-6.707a1 1 0 0 1 0 1.414l-8.4 8.4a1 1 0 0 1-1.414 0l-2.4-2.4a1 1 0 1 1 1.414-1.414l1.693 1.693 7.693-7.693a1 1 0 0 1 1.414 0Z"
  />,
  'CheckBroken'
)
